module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet-894b8ef5e4c2f94e48dc8c41e70b09b9.jpg";